<template>
<div class="chapter">
<div class="inner_page">
<h1>The Road to Oz</h1>
<h2 class="sigil_not_in_toc" id="pgepubid00002">L. Frank Baum</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?3b0c4ce9